// import OpenReplayTracker from '@openreplay/tracker'

let tracker
function init() {
  // if (
  //   process.env.NODE_ENV === 'development' &&
  //   !localStorage.getItem('open-replay')
  // )
  //   return
  // tracker = new OpenReplayTracker({
  //   projectKey: 'gmTEratElFVGKlrdiYIo',
  //   __DISABLE_SECURE_MODE: process.env.NODE_ENV === 'development'
  // })
  // tracker.start()
}

init()

export function getOpenReplayTracker() {
  return tracker
}
